import {CheckIcon, DashIcon, TriangleDownIcon, XIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button, ButtonGroup, IconButton} from '@primer/react'
import {RESOLUTION_REASON_OPTIONS, type ResolutionReasonType} from '../../conversation-types'

const iconMap = {
  check: CheckIcon,
  x: XIcon,
  dash: DashIcon,
} as const

export interface ResolveThreadSplitButtonProps {
  resolveButtonLabel: string
  onResolve: (resolutionReason?: ResolutionReasonType) => void
}

export function ResolveThreadSplitButton({resolveButtonLabel, onResolve}: ResolveThreadSplitButtonProps) {
  return (
    <ButtonGroup>
      <Button aria-label={resolveButtonLabel} onClick={() => onResolve()}>
        Resolve comment
      </Button>
      <ActionMenu>
        <ActionMenu.Anchor>
          <IconButton aria-label="Resolve with reason" icon={TriangleDownIcon} />
        </ActionMenu.Anchor>
        <ActionMenu.Overlay width="medium" align="end">
          <ActionList>
            {RESOLUTION_REASON_OPTIONS.map(option => {
              const Icon = iconMap[option.icon]
              return (
                <ActionList.Item key={option.value} onSelect={() => onResolve(option.value)}>
                  <ActionList.LeadingVisual>
                    <Icon />
                  </ActionList.LeadingVisual>
                  {option.label}
                  <ActionList.Description variant="block">{option.description}</ActionList.Description>
                </ActionList.Item>
              )
            })}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </ButtonGroup>
  )
}
